import React from "react";

import cn from "classnames";

import { TEXT_LINK_DISPLAY_NAME } from "./utils/core";
import { boxForwardRef } from "../../../helpers/common/Box/Box";
import TextCore from "../../../helpers/common/TextCore/TextCore";

import type { TextLinkProps } from "./types";
import type { BoxComponentWithDefault } from "../../../helpers/common/Box/Box";

import classes from "./TextLink.styl";

/**
 * Полиморфный компонент, являющийся надстройкой над компонентом &lt;Text /&gt; с добавлением параметра `view` и интерактивности.
 *
 * @constructor
 */
export const TextLink = boxForwardRef<
    BoxComponentWithDefault<"a", TextLinkProps, "className" | "style">
>(
    (
        {
            as = "a",
            view = "primary",
            children,
            "data-tsid": tsid,
            customColorsStyles,
            customVarsStyles,
            ...props
        },
        ref,
    ) => {
        const textLinkTextClassName = cn(
            classes["text-link"],
            view !== "primary" && classes[`__view-${view}`],
        );

        const textLinkCustomVarsStyles = cn(
            customVarsStyles && [
                classes["text-link-custom-vars"],
                customVarsStyles,
            ],
            customColorsStyles,
        );

        return (
            <TextCore
                as={as}
                data-tsid={tsid}
                data-uikit={TEXT_LINK_DISPLAY_NAME}
                textClassName={textLinkTextClassName}
                {...props}
                customVarsStyles={textLinkCustomVarsStyles}
                ref={ref}
            >
                {children}
            </TextCore>
        );
    },
);

TextLink.displayName = TEXT_LINK_DISPLAY_NAME;

export default TextLink;
